import { useEffect, useState } from 'react';
import axios from 'utils/axiosInstance';
import { Pcomment } from 'types/pcomment';
import { UserInfo } from 'types/user_info';
import CommentItem from './CommentItem';
import CommentForm from './CommentForm';

interface CommentSectionProps {
    noteId: number;
    isLoggedIn: boolean;
    userInfo: UserInfo | null;
}

const CommentSection = ({ noteId, isLoggedIn, userInfo }: CommentSectionProps) => {
    const [comments, setComments] = useState<Pcomment[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchComments();
    }, [noteId]);

    const fetchComments = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/api/v1/notes/${noteId}/pcomments`);
            if (response.data.success) {
                setComments(response.data.items || []);
            }
        } catch (error) {
            console.error('댓글 로딩 실패:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCommentCreated = (newComment: Pcomment) => {
        // 트리 구조로 정렬하기 위해 다시 페치 (또는 클라이언트 사이드 삽입 로직 필요)
        // 간단하게 다시 페치함
        fetchComments();
    };

    return (
        <div className="mt-10 pt-10 border-t border-gray-200">
            <div className="flex items-center gap-2 mb-6">
                <h3 className="text-xl font-bold">댓글</h3>
                <span className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full text-sm">
                    {comments.length}
                </span>
            </div>

            <div className="mb-8">
                <CommentForm
                    noteId={noteId}
                    onCommentCreated={handleCommentCreated}
                    isLoggedIn={isLoggedIn}
                />
            </div>

            {isLoading ? (
                <div className="flex justify-center py-10">
                    <span className="loading loading-spinner loading-md"></span>
                </div>
            ) : (
                <div className="space-y-4">
                    {comments.length > 0 ? (
                        comments.map((comment) => (
                            <CommentItem
                                key={comment.id}
                                comment={comment}
                                noteId={noteId}
                                isLoggedIn={isLoggedIn}
                                userInfo={userInfo}
                                onCommentCreated={handleCommentCreated}
                            />
                        ))
                    ) : (
                        <div className="text-center py-10 text-gray-400 text-sm">
                            첫 번째 댓글을 남겨보세요.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CommentSection;
